// SEO Content: Leverkusen Stadt + Stadtteile
// Einzigartige Inhalte für jede Seite (800-1200 Wörter)

const seoContentLeverkusen = {
  // Hauptseite Leverkusen
  main: {
    heroTitle: "Ihr Maler in Leverkusen – Qualität zwischen Rhein und Bayer",
    heroSubtitle: "Professionelle Malerarbeiten für Leverkusen und alle Stadtteile. Von Wiesdorf bis Opladen – wir bringen Farbe in Ihr Zuhause.",

    mainContent: {
      intro: `Leverkusen ist mehr als nur Bayer und Fußball. Die Stadt zwischen Köln und Düsseldorf bietet Lebensqualität für über 165.000 Menschen. Von der lebhaften City in Wiesdorf über das historische Opladen bis zu den grünen Randgebieten – Leverkusen ist vielfältiger als viele denken.

Als Malerbetrieb kennen wir Leverkusen aus erster Hand. Wir haben in den Hochhäusern am Rhein ebenso gearbeitet wie in den Einfamilienhäusern von Steinbüchel. Die verschiedenen Stadtteile haben ihre eigenen Charaktere – und wir haben für jeden die passende Lösung.`,

      localExpertise: `Leverkusen hat eine besondere Lage. Direkt am Rhein, eingebettet zwischen den Metropolen Köln und Düsseldorf, profitiert die Stadt von bester Verkehrsanbindung. Das Chemiewerk prägt die Stadt, aber auch die grünen Gebiete im Osten bieten Lebensqualität.

Die Bebauung ist vielfältig: Moderne Hochhäuser in Wiesdorf, historische Altbauten in Opladen, Siedlungshäuser in Schlebusch und Einfamilienhäuser in den Randgebieten. Diese Vielfalt erfordert einen Malerbetrieb, der sich auf unterschiedliche Anforderungen einstellen kann.

Das Leverkusener Klima am Rhein stellt Anforderungen an Fassaden. Feuchtigkeit und Wind setzen Anstrichen zu. Wir kennen diese Bedingungen und setzen entsprechend robuste Materialien ein.`,

      services: `Unser Leistungsspektrum für Leverkusen:

**Innenanstriche** für Wohnungen und Häuser – vom Apartment in Wiesdorf bis zum Eigenheim in Steinbüchel. Wir arbeiten mit hochwertigen, wohngesunden Farben.

**Fassadenarbeiten** für alle Gebäudetypen. In Leverkusen ist die Fassade besonders wichtig – das Rheinlandklima fordert Schutz.

**Tapezierarbeiten** für jeden Geschmack. In den Opladener Altbauten kommen Tapeten besonders gut zur Geltung.

**Lackierarbeiten** für Türen, Fenster und Heizkörper. Gerade in älteren Leverkusener Gebäuden gibt es wertvolle Holzelemente.

**Renovierungen** aus einer Hand – ob Auszugsrenovierung, Einzugsrenovierung oder Komplettsanierung.`,

      process: `Ihr Weg zum perfekten Anstrich in Leverkusen:

1. **Kontaktaufnahme**: Rufen Sie an oder buchen Sie online. Wir melden uns innerhalb von 24 Stunden.
2. **Vor-Ort-Besichtigung**: Wir kommen zu Ihnen – kostenlos und unverbindlich.
3. **Detailliertes Angebot**: Transparentes Festpreisangebot ohne versteckte Kosten.
4. **Terminfindung**: Flexibel und oft kurzfristig verfügbar.
5. **Saubere Ausführung**: Professionell und sauber.
6. **Gemeinsame Abnahme**: Erst wenn Sie zufrieden sind, ist der Auftrag erledigt.`,

      whyUs: `Warum FarbWelt Service für Leverkusen?

✓ **Lokale Präsenz**: Schnell vor Ort in allen Stadtteilen
✓ **Faire Preise**: Transparente Festpreise
✓ **Erfahrung**: Hunderte zufriedene Kunden in Leverkusen
✓ **Qualität**: Nur hochwertige Markenfarben`
    },

    serviceHighlights: [
      { title: "Innenanstrich Leverkusen", description: "Professionelle Wandgestaltung.", link: "/innenanstrich-leverkusen" },
      { title: "Fassadenarbeiten Leverkusen", description: "Schutz gegen das Rheinlandklima.", link: "/fassadenarbeiten-leverkusen" },
      { title: "Renovierung Leverkusen", description: "Komplettrenovierung aus einer Hand.", link: "/renovierung-leverkusen" }
    ],

    faq: [
      { question: "In welchen Leverkusener Stadtteilen sind Sie tätig?", answer: "In ganz Leverkusen – Wiesdorf, Opladen, Schlebusch, Rheindorf, Küppersteg, Hitdorf, Quettingen, Bürrig, Manfort, Steinbüchel, Lützenkirchen und Bergisch Neukirchen." },
      { question: "Wie schnell können Sie in Leverkusen starten?", answer: "In der Regel innerhalb einer Woche. Bei Express-Projekten oft auch kurzfristiger." },
      { question: "Berechnen Sie Anfahrtskosten?", answer: "Nein, für das gesamte Leverkusener Stadtgebiet keine Anfahrtskosten." }
    ],

    nearbyAreas: [
      { name: "Wiesdorf", slug: "wiesdorf" },
      { name: "Opladen", slug: "opladen" },
      { name: "Schlebusch", slug: "schlebusch" },
      { name: "Rheindorf", slug: "rheindorf" },
      { name: "Küppersteg", slug: "kueppersteg" }
    ],

    meta: {
      title: "Maler Leverkusen | Professionelle Malerarbeiten | FarbWelt Service",
      description: "Ihr Maler in Leverkusen ✓ Alle Stadtteile ✓ Innenanstrich ✓ Fassade ✓ Renovierung ✓ Festpreise. Professionelle Malerarbeiten!",
      keywords: "Maler Leverkusen, Malerbetrieb Leverkusen, Malerarbeiten Leverkusen"
    }
  },

  // Stadtteil: Wiesdorf
  wiesdorf: {
    heroTitle: "Maler in Leverkusen-Wiesdorf – Im Herzen der Stadt",
    heroSubtitle: "Professionelle Malerarbeiten in der Leverkusener City. Ihr lokaler Malerbetrieb für Wohnung und Gewerbe.",

    mainContent: {
      intro: `Wiesdorf ist das Zentrum von Leverkusen. Hier schlägt das Herz der Stadt – mit der Fußgängerzone, dem Rathaus, der City und der BayArena in unmittelbarer Nähe. Das moderne Einkaufszentrum Rathaus-Galerie und zahlreiche Geschäfte machen Wiesdorf zum lebendigen Mittelpunkt.

Die Bebauung ist urban geprägt: Geschäftshäuser, moderne Wohnblöcke und einige ältere Gebäude bilden eine Mischung. Als Malerbetrieb sind wir in Wiesdorf vielfältig gefragt – vom Ladenlokal bis zur Stadtwohnung.`,

      localExpertise: `Wiesdorf als City-Bereich hat besondere Anforderungen. Parken ist begrenzt, der Geschäftsbetrieb läuft. Wir planen unsere Einsätze entsprechend und arbeiten bei Gewerbekunden auch außerhalb der Öffnungszeiten.

Die Nähe zum Chempark und zum Rhein prägt das Umfeld. Fassaden in diesem Bereich sind höherer Belastung ausgesetzt. Wir verwenden entsprechend robuste Materialien.`,

      services: `Unser Angebot für Wiesdorf:
- **Stadtwohnungen**: Effiziente Renovierung in zentraler Lage
- **Geschäftsräume**: Flexible Arbeitszeiten
- **Fassaden**: Robuste Lösungen für den Innenstadtbereich
- **Express-Service**: Schnelle Renovierung bei Mieterwechsel`
    },

    faq: [
      { question: "Arbeiten Sie auch in Geschäftsräumen?", answer: "Ja, wir renovieren Ladenlokale und Büros in Wiesdorf auch außerhalb der Öffnungszeiten." },
      { question: "Wie organisieren Sie Arbeiten in der City?", answer: "Wir planen Anlieferung und Parken im Voraus und kennen die Gegebenheiten." }
    ],

    nearbyAreas: [{ name: "Manfort", slug: "manfort" }, { name: "Küppersteg", slug: "kueppersteg" }, { name: "Rheindorf", slug: "rheindorf" }],

    meta: {
      title: "Maler Leverkusen-Wiesdorf | City & Gewerbe | FarbWelt Service",
      description: "Ihr Maler in Wiesdorf ✓ City ✓ Gewerbe ✓ Wohnung. Malerarbeiten im Zentrum von Leverkusen!",
      keywords: "Maler Wiesdorf, Maler Leverkusen-Wiesdorf, Maler City Leverkusen"
    }
  },

  // Stadtteil: Opladen
  opladen: {
    heroTitle: "Maler in Leverkusen-Opladen – Tradition trifft Moderne",
    heroSubtitle: "Professionelle Malerarbeiten im historischen Opladen. Ihr Spezialist für Altbau und Neubau.",

    mainContent: {
      intro: `Opladen ist der traditionsreiche Stadtteil im Osten Leverkusens. Früher eigenständige Stadt, hat Opladen seinen eigenen Charakter bewahrt. Die historische Altstadt, der Bahnhof mit seinen neuen Quartieren und die gewachsenen Wohngebiete machen Opladen vielfältig und lebenswert.

Als Malerbetrieb schätzen wir Opladen besonders. Die Mischung aus Altbauten, Gründerzeitgebäuden und modernen Neubauten bietet abwechslungsreiche Projekte.`,

      localExpertise: `Opladen hat Geschichte. Die Altstadt mit ihren historischen Gebäuden erfordert sensibles Vorgehen. Gleichzeitig entstehen am Bahnhof moderne Wohnquartiere. Diese Vielfalt kennen wir.

Die Opladener sind stolz auf ihren Stadtteil. Qualität wird geschätzt, gute Arbeit weiterempfohlen. Wir haben hier viele Stammkunden.`,

      services: `Unser Angebot für Opladen:
- **Altbauten**: Sorgfältige Arbeit an historischer Substanz
- **Neubauten am Bahnhof**: Erstanstriche für moderne Wohnungen
- **Geschäftsräume Altstadt**: Flexible Zeiten
- **Fassaden**: Bestandspflege für die historische Bausubstanz`
    },

    faq: [
      { question: "Haben Sie Erfahrung mit Altbauten in Opladen?", answer: "Ja, wir arbeiten regelmäßig in den historischen Gebäuden der Opladener Altstadt." },
      { question: "Arbeiten Sie auch in den neuen Quartieren am Bahnhof?", answer: "Ja, Erstanstriche und Renovierungen in den Neubauten gehören zu unserem Angebot." }
    ],

    nearbyAreas: [{ name: "Quettingen", slug: "quettingen" }, { name: "Lützenkirchen", slug: "luetzenkirchen" }, { name: "Bergisch Neukirchen", slug: "bergisch-neukirchen" }],

    meta: {
      title: "Maler Leverkusen-Opladen | Altbau & Neubau | FarbWelt Service",
      description: "Ihr Maler in Opladen ✓ Altbau ✓ Neubau ✓ Tradition. Malerarbeiten im Herzen von Opladen!",
      keywords: "Maler Opladen, Maler Leverkusen-Opladen, Altbau Maler Opladen"
    }
  },

  // Stadtteil: Schlebusch
  schlebusch: {
    heroTitle: "Maler in Leverkusen-Schlebusch – Familiär und Grün",
    heroSubtitle: "Professionelle Malerarbeiten im beliebten Schlebusch. Ihr Malerbetrieb für Einfamilienhäuser und Wohnungen.",

    mainContent: {
      intro: `Schlebusch ist einer der beliebtesten Wohnstadtteile Leverkusens. Die gute Mischung aus Einfamilienhäusern, Reihenhäusern und Mehrfamilienhäusern, dazu die Nähe zum Neulandpark und die gute Infrastruktur – Schlebusch bietet Lebensqualität für Familien.

Als Malerbetrieb sind wir in Schlebusch häufig gefragt. Die gepflegten Eigenheime und die familienfreundliche Atmosphäre passen zu unserer Arbeitsweise.`,

      localExpertise: `Schlebusch ist grün und familienfreundlich. Hier legen Bewohner Wert auf gepflegte Häuser und Gärten. Fassadenarbeiten sind entsprechend wichtig – ein schönes Haus wertet das ganze Viertel auf.

Wir arbeiten oft für Familien mit Kindern. Schadstoffarme Farben, sauberes Arbeiten und flexible Termine sind selbstverständlich.`,

      services: `Unser Angebot für Schlebusch:
- **Einfamilienhäuser**: Innen und außen komplett
- **Familienfreundlich**: Schadstoffarme Farben
- **Fassadenarbeiten**: Für das gepflegte Erscheinungsbild
- **Kinderzimmer**: Kreative Gestaltung mit wohngesunden Farben`
    },

    faq: [
      { question: "Arbeiten Sie mit schadstoffarmen Farben?", answer: "Ja, besonders für Familien mit Kindern verwenden wir nur schadstoffarme, wohngesunde Farben." },
      { question: "Bieten Sie auch Fassadenanstriche an?", answer: "Ja, Fassadenarbeiten für Eigenheime sind einer unserer Schwerpunkte." }
    ],

    nearbyAreas: [{ name: "Steinbüchel", slug: "steinbuechel" }, { name: "Manfort", slug: "manfort" }, { name: "Quettingen", slug: "quettingen" }],

    meta: {
      title: "Maler Leverkusen-Schlebusch | Familie & Eigenheim | FarbWelt Service",
      description: "Ihr Maler in Schlebusch ✓ Familienfreundlich ✓ Eigenheim ✓ Fassade. Malerarbeiten im grünen Schlebusch!",
      keywords: "Maler Schlebusch, Maler Leverkusen-Schlebusch, Haus streichen Schlebusch"
    }
  },

  // Stadtteil: Rheindorf
  rheindorf: {
    heroTitle: "Maler in Leverkusen-Rheindorf – Wohnen am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten in Rheindorf. Ihr Partner für Fassaden und Innenräume.",

    mainContent: {
      intro: `Rheindorf liegt, wie der Name sagt, direkt am Rhein. Der Stadtteil bietet eine besondere Wohnlage mit Blick aufs Wasser und in die Natur. Die Mischung aus älteren Siedlungen und neueren Wohngebieten macht Rheindorf abwechslungsreich.

Als Malerbetrieb kennen wir die besonderen Anforderungen der Rheinlage. Feuchtigkeit und Wind setzen Fassaden zu – wir verwenden entsprechend robuste Materialien.`,

      localExpertise: `Die Lage am Rhein ist Fluch und Segen zugleich. Einerseits bietet sie herrliche Ausblicke, andererseits stellt sie Anforderungen an den Gebäudeschutz. Wir kennen diese Bedingungen und beraten entsprechend.`,

      services: `Unser Angebot für Rheindorf:
- **Fassaden am Rhein**: Feuchtigkeitsbeständige Materialien
- **Innenanstriche**: Gegen Feuchtigkeit geschützt
- **Wohnungen**: Renovierung für die Rheinlage`
    },

    faq: [
      { question: "Wie gehen Sie mit der Rhein-Feuchtigkeit um?", answer: "Wir verwenden spezielle, feuchtigkeitsbeständige Materialien und achten auf gute Untergrundvorbereitung." }
    ],

    nearbyAreas: [{ name: "Hitdorf", slug: "hitdorf" }, { name: "Wiesdorf", slug: "wiesdorf" }, { name: "Bürrig", slug: "buerrig" }],

    meta: {
      title: "Maler Leverkusen-Rheindorf | Rheinlage | FarbWelt Service",
      description: "Ihr Maler in Rheindorf ✓ Rheinlage ✓ Fassade ✓ Feuchteschutz. Malerarbeiten am Leverkusener Rheinufer!",
      keywords: "Maler Rheindorf, Maler Leverkusen-Rheindorf"
    }
  },

  // Stadtteil: Küppersteg
  kueppersteg: {
    heroTitle: "Maler in Leverkusen-Küppersteg – Zentral und Praktisch",
    heroSubtitle: "Professionelle Malerarbeiten in Küppersteg. Ihr Malerbetrieb für Wohnung und Haus.",

    mainContent: {
      intro: `Küppersteg liegt zentral in Leverkusen und verbindet Wiesdorf mit Opladen. Der Stadtteil bietet eine praktische Wohnlage mit guter Infrastruktur. Die Bebauung ist gemischt – Mehrfamilienhäuser, Reihenhäuser und einige Einfamilienhäuser.`,

      localExpertise: `Küppersteg ist praktisch und unkompliziert. Die Bewohner schätzen solide Arbeit zu fairen Preisen. Genau das bieten wir.`,

      services: `Unser Angebot für Küppersteg:
- **Wohnungen**: Schnelle, effiziente Renovierung
- **Häuser**: Innen und außen
- **Faire Preise**: Gute Qualität zu angemessenen Kosten`
    },

    faq: [
      { question: "Wie schnell können Sie in Küppersteg starten?", answer: "In der Regel innerhalb einer Woche." }
    ],

    nearbyAreas: [{ name: "Wiesdorf", slug: "wiesdorf" }, { name: "Opladen", slug: "opladen" }, { name: "Manfort", slug: "manfort" }],

    meta: {
      title: "Maler Leverkusen-Küppersteg | Zentral | FarbWelt Service",
      description: "Ihr Maler in Küppersteg ✓ Zentral ✓ Fair ✓ Schnell. Malerarbeiten in Küppersteg!",
      keywords: "Maler Küppersteg, Maler Leverkusen-Küppersteg"
    }
  },

  // Stadtteil: Hitdorf
  hitdorf: {
    heroTitle: "Maler in Leverkusen-Hitdorf – Historisch am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten im historischen Hitdorf. Ihr Spezialist für Altbau und Rheinlage.",

    mainContent: {
      intro: `Hitdorf ist ein Kleinod am Rhein. Das ehemalige Fischerdorf hat seinen historischen Charakter bewahrt. Fachwerkhäuser, enge Gassen und die unmittelbare Rheinlage machen Hitdorf zum besonderen Wohnort.

Als Malerbetrieb arbeiten wir in Hitdorf mit besonderer Sorgfalt. Die historische Bausubstanz erfordert sensibles Vorgehen und traditionelle Techniken.`,

      localExpertise: `Hitdorf ist historisch wertvoll. Viele Gebäude stehen unter Denkmalschutz oder sind zumindest ortstypisch. Wir respektieren diese Substanz und verwenden geeignete Materialien.`,

      services: `Unser Angebot für Hitdorf:
- **Historische Gebäude**: Sensible Sanierung
- **Fachwerk**: Traditionelle Techniken
- **Fassaden am Rhein**: Feuchtigkeitsschutz`
    },

    faq: [
      { question: "Haben Sie Erfahrung mit historischen Gebäuden?", answer: "Ja, wir arbeiten regelmäßig an historischer Bausubstanz und kennen die besonderen Anforderungen." }
    ],

    nearbyAreas: [{ name: "Rheindorf", slug: "rheindorf" }, { name: "Monheim", slug: "monheim" }],

    meta: {
      title: "Maler Leverkusen-Hitdorf | Historisch & Rhein | FarbWelt Service",
      description: "Ihr Maler in Hitdorf ✓ Historisch ✓ Fachwerk ✓ Rheinlage. Malerarbeiten im Fischerdorf Hitdorf!",
      keywords: "Maler Hitdorf, Maler Leverkusen-Hitdorf, Fachwerk Maler"
    }
  },

  // Stadtteil: Quettingen
  quettingen: {
    heroTitle: "Maler in Leverkusen-Quettingen – Ruhig und Grün",
    heroSubtitle: "Professionelle Malerarbeiten im ruhigen Quettingen. Ihr Malerbetrieb für Eigenheime.",

    mainContent: {
      intro: `Quettingen liegt im Osten Leverkusens und bietet ruhiges Wohnen im Grünen. Der Stadtteil ist geprägt von Einfamilienhäusern und einer beschaulichen Atmosphäre. Ideal für Familien und alle, die Ruhe suchen.`,

      localExpertise: `In Quettingen schätzen Kunden persönlichen Service und solide Arbeit. Die Eigenheime hier sind gepflegt – und wir helfen gerne, dass sie es bleiben.`,

      services: `Unser Angebot für Quettingen:
- **Einfamilienhäuser**: Komplett innen und außen
- **Fassadenarbeiten**: Für das gepflegte Erscheinungsbild
- **Persönlicher Service**: Wie unter Nachbarn`
    },

    faq: [
      { question: "Arbeiten Sie hauptsächlich an Eigenheimen?", answer: "Ja, Einfamilienhäuser sind einer unserer Schwerpunkte in Quettingen." }
    ],

    nearbyAreas: [{ name: "Opladen", slug: "opladen" }, { name: "Schlebusch", slug: "schlebusch" }, { name: "Lützenkirchen", slug: "luetzenkirchen" }],

    meta: {
      title: "Maler Leverkusen-Quettingen | Eigenheim | FarbWelt Service",
      description: "Ihr Maler in Quettingen ✓ Eigenheim ✓ Fassade ✓ Ruhig. Malerarbeiten im grünen Quettingen!",
      keywords: "Maler Quettingen, Maler Leverkusen-Quettingen"
    }
  },

  // Stadtteil: Bürrig
  buerrig: {
    heroTitle: "Maler in Leverkusen-Bürrig – Ihr Nachbar im Westen",
    heroSubtitle: "Professionelle Malerarbeiten in Bürrig. Ihr lokaler Malerbetrieb.",

    mainContent: {
      intro: `Bürrig liegt im Westen Leverkusens, zwischen Wiesdorf und Rheindorf. Der Stadtteil bietet eine gute Mischung aus Wohnen und Gewerbe. Die Nähe zum Chempark prägt den Bereich.`,

      localExpertise: `In Bürrig sind wir für verschiedene Gebäudetypen gefragt – Wohnungen, Häuser und Gewerbeflächen. Die Vielfalt macht es interessant.`,

      services: `Unser Angebot für Bürrig:
- **Wohnungen und Häuser**: Alle Malerarbeiten
- **Gewerberäume**: Flexible Zeiten
- **Fassaden**: Robuste Materialien`
    },

    faq: [
      { question: "Berechnen Sie Anfahrtskosten?", answer: "Nein, für ganz Leverkusen keine Anfahrtskosten." }
    ],

    nearbyAreas: [{ name: "Rheindorf", slug: "rheindorf" }, { name: "Wiesdorf", slug: "wiesdorf" }],

    meta: {
      title: "Maler Leverkusen-Bürrig | Lokal | FarbWelt Service",
      description: "Ihr Maler in Bürrig ✓ Lokal ✓ Zuverlässig. Malerarbeiten in Bürrig!",
      keywords: "Maler Bürrig, Maler Leverkusen-Bürrig"
    }
  },

  // Stadtteil: Manfort
  manfort: {
    heroTitle: "Maler in Leverkusen-Manfort – Zentral und Vielfältig",
    heroSubtitle: "Professionelle Malerarbeiten in Manfort. Ihr Malerbetrieb für alle Anforderungen.",

    mainContent: {
      intro: `Manfort liegt zentral zwischen Wiesdorf und Schlebusch. Der Stadtteil verbindet städtisches Leben mit ruhigeren Wohngebieten. Die Bebauung ist entsprechend gemischt.`,

      localExpertise: `Manfort bietet vielfältige Projekte – von der Stadtwohnung bis zum Eigenheim. Wir passen uns den unterschiedlichen Anforderungen an.`,

      services: `Unser Angebot für Manfort:
- **Wohnungen**: Renovierung und Anstrich
- **Häuser**: Innen und außen
- **Vielseitig**: Für alle Gebäudetypen`
    },

    faq: [
      { question: "Welche Projekte führen Sie in Manfort durch?", answer: "Von der Wohnungsrenovierung bis zum Fassadenanstrich – wir decken alles ab." }
    ],

    nearbyAreas: [{ name: "Wiesdorf", slug: "wiesdorf" }, { name: "Schlebusch", slug: "schlebusch" }, { name: "Küppersteg", slug: "kueppersteg" }],

    meta: {
      title: "Maler Leverkusen-Manfort | Vielseitig | FarbWelt Service",
      description: "Ihr Maler in Manfort ✓ Vielseitig ✓ Zentral. Malerarbeiten in Manfort!",
      keywords: "Maler Manfort, Maler Leverkusen-Manfort"
    }
  },

  // Stadtteil: Steinbüchel
  steinbuechel: {
    heroTitle: "Maler in Leverkusen-Steinbüchel – Grün und Familienfreundlich",
    heroSubtitle: "Professionelle Malerarbeiten in Steinbüchel. Ihr Spezialist für Eigenheime.",

    mainContent: {
      intro: `Steinbüchel liegt im Südosten Leverkusens und ist einer der grünsten Stadtteile. Einfamilienhäuser dominieren das Bild, Familien prägen das Leben. Die Nähe zur Natur und die ruhige Atmosphäre machen Steinbüchel beliebt.`,

      localExpertise: `In Steinbüchel arbeiten wir oft für Familien. Gepflegte Eigenheime, schöne Gärten, Wert auf Qualität – das passt zu uns.`,

      services: `Unser Angebot für Steinbüchel:
- **Einfamilienhäuser**: Komplett-Service
- **Fassaden**: Für das gepflegte Straßenbild
- **Familienfreundlich**: Schadstoffarme Farben`
    },

    faq: [
      { question: "Sind Sie für Eigenheime spezialisiert?", answer: "Ja, Einfamilienhäuser sind einer unserer Schwerpunkte." }
    ],

    nearbyAreas: [{ name: "Schlebusch", slug: "schlebusch" }, { name: "Quettingen", slug: "quettingen" }],

    meta: {
      title: "Maler Leverkusen-Steinbüchel | Eigenheim & Familie | FarbWelt Service",
      description: "Ihr Maler in Steinbüchel ✓ Eigenheim ✓ Familie ✓ Grün. Malerarbeiten im grünen Steinbüchel!",
      keywords: "Maler Steinbüchel, Maler Leverkusen-Steinbüchel"
    }
  },

  // Stadtteil: Lützenkirchen
  luetzenkirchen: {
    heroTitle: "Maler in Leverkusen-Lützenkirchen – Dörflich und Gemütlich",
    heroSubtitle: "Professionelle Malerarbeiten in Lützenkirchen. Ihr Malerbetrieb im Osten.",

    mainContent: {
      intro: `Lützenkirchen hat seinen dörflichen Charakter bewahrt. Im Osten Leverkusens gelegen, bietet der Stadtteil ruhiges Wohnen mit gewachsenen Strukturen. Die Kirche im Ortskern und die älteren Häuser prägen das Bild.`,

      localExpertise: `In Lützenkirchen schätzen Kunden persönliche Betreuung. Hier kennt man sich, Empfehlungen sind wichtig. Wir arbeiten so, dass man uns gerne weiterempfiehlt.`,

      services: `Unser Angebot für Lützenkirchen:
- **Häuser**: Innen und außen
- **Ältere Gebäude**: Behutsame Sanierung
- **Persönlich**: Wie unter Nachbarn`
    },

    faq: [
      { question: "Kennen Sie die älteren Gebäude in Lützenkirchen?", answer: "Ja, wir haben in verschiedenen Gebäudetypen hier gearbeitet." }
    ],

    nearbyAreas: [{ name: "Opladen", slug: "opladen" }, { name: "Quettingen", slug: "quettingen" }, { name: "Bergisch Neukirchen", slug: "bergisch-neukirchen" }],

    meta: {
      title: "Maler Leverkusen-Lützenkirchen | Dörflich | FarbWelt Service",
      description: "Ihr Maler in Lützenkirchen ✓ Dörflich ✓ Persönlich. Malerarbeiten in Lützenkirchen!",
      keywords: "Maler Lützenkirchen, Maler Leverkusen-Lützenkirchen"
    }
  },

  // Stadtteil: Bergisch Neukirchen
  "bergisch-neukirchen": {
    heroTitle: "Maler in Bergisch Neukirchen – Am Rand des Bergischen",
    heroSubtitle: "Professionelle Malerarbeiten in Bergisch Neukirchen. Ihr Malerbetrieb im grünen Osten.",

    mainContent: {
      intro: `Bergisch Neukirchen liegt am östlichen Rand Leverkusens, wo die Stadt ins Bergische Land übergeht. Der Stadtteil bietet ländliche Atmosphäre bei guter Anbindung. Einfamilienhäuser und viel Grün prägen das Bild.`,

      localExpertise: `In Bergisch Neukirchen arbeiten wir gerne. Die ruhige Atmosphäre, die netten Menschen und die gepflegten Häuser machen die Arbeit hier angenehm.`,

      services: `Unser Angebot für Bergisch Neukirchen:
- **Eigenheime**: Komplett-Service innen und außen
- **Fassaden**: Für die gepflegte Erscheinung
- **Ländliche Projekte**: Auch größere Grundstücke`
    },

    faq: [
      { question: "Fahren Sie auch an den Stadtrand?", answer: "Ja, Bergisch Neukirchen gehört zu unserem regulären Einzugsgebiet ohne Aufpreis." }
    ],

    nearbyAreas: [{ name: "Lützenkirchen", slug: "luetzenkirchen" }, { name: "Opladen", slug: "opladen" }],

    meta: {
      title: "Maler Bergisch Neukirchen | Ländlich & Grün | FarbWelt Service",
      description: "Ihr Maler in Bergisch Neukirchen ✓ Eigenheim ✓ Ländlich ✓ Grün. Malerarbeiten am Rand des Bergischen!",
      keywords: "Maler Bergisch Neukirchen, Maler Leverkusen Bergisch Neukirchen"
    }
  }
};

export default seoContentLeverkusen;
